module.exports = __webpack_public_path__ + "static/media/gb.07235417.png";